/* CDROX 2026-08-17 (DOM-02): hidrata as listas do seletor de pais/idioma que nasceram
 * dentro de <template data-cdrox-loc>.
 *
 * Por que: snippets/localization-selector.liquid e renderizado 3x na mesma pagina (topo em
 * desktop, menu drawer no mobile, rodape) e cada copia mandava a lista completa dos 29 paises
 * mais a dos 2 idiomas. Medido na loja: 6 popovers, 42,6 KB, 321 tags e 93 botoes em TODA
 * pagina - 14% do DOM da home e 34% do DOM da PDP, tudo invisivel ate alguem clicar.
 * Dentro de <template> o conteudo e inerte: nao vira DOM, nao computa estilo, nao faz layout
 * e nao baixa as bandeiras.
 *
 * Quando hidrata (o que vier primeiro):
 *   1. primeiro pointerdown/click/foco/tecla no botao do seletor ou dentro do popover, em fase
 *      de CAPTURA, ou seja ANTES do handler do tema que chama Popover.show(). 'click' entra
 *      junto porque clique sintetico (el.click(), automacao, leitor de tela) nao emite
 *      pointerdown; 'keydown' e 'focusin' cobrem navegacao por teclado.
 *   2. no primeiro periodo ocioso depois do load, como rede de seguranca para qualquer caminho
 *      que abra o popover por script sem passar por evento de entrada.
 *
 * O botao visivel (bandeira + nome do pais + moeda + chevron) fica FORA do template: o layout
 * do topo, do drawer e do rodape nao muda em nada.
 */
(function () {
  if (window.__cdroxLocLazy) return;
  window.__cdroxLocLazy = true;

  var hidratar = function () {
    var alvos = document.querySelectorAll('template[data-cdrox-loc]');
    var n = 0;
    Array.prototype.forEach.call(alvos, function (tpl) {
      if (!tpl.parentNode) return;
      try {
        tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
        tpl.remove();
        n++;
      } catch (e) {
        /* falha numa copia nao pode derrubar as outras */
      }
    });
    return n;
  };

  var aoInteragir = function (e) {
    var alvo = e.target;
    if (!alvo || !alvo.closest) return;
    if (!alvo.closest('[aria-controls^="popover-localization"], x-popover[id^="popover-localization"]')) return;
    hidratar();
  };

  ['pointerdown', 'click', 'focusin', 'keydown'].forEach(function (evt) {
    document.addEventListener(evt, aoInteragir, true);
  });

  var quandoOcioso = function () {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { hidratar(); }, { timeout: 4000 });
    } else {
      setTimeout(hidratar, 1500);
    }
  };
  if (document.readyState === 'complete') quandoOcioso();
  else window.addEventListener('load', quandoOcioso, { once: true });

  /* editor de tema: section recarregada traz template novo */
  document.addEventListener('shopify:section:load', function () { hidratar(); });
})();
